import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import APIS from "../../../../../constant/Endpoint";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  const blogResponse = await getApiData(APIS.BLOG, {});
  const blogCatResponse = await getApiData(APIS.BLOG_CATEGORY, {});
  const blogAuthorResponse = await getApiData(APIS.AUTHOR, {});
  const blogTagResponse = await getApiData(APIS.TAG, {});

  Components.addType("reliable-blog-list", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("reliable-blog-list")
      ) {
        return {
          type: "reliable-blog-list",
        };
      }
    },
    model: {
      defaults: {
        traits: [
          {
            type: "select",
            label: "Type",
            name: "type",
            options: [
              { id: "category", name: "Category" },
              { id: "author", name: "Author" },
              { id: "tag", name: "Tag" },
              { id: "similar", name: "Similar" },
            ],
          },
          {
            type: "select",
            label: "Category",
            name: "category",
            options: blogCatResponse?.data ?? [],
          },
          {
            type: "select",
            label: "Author",
            name: "author",
            options: blogAuthorResponse?.data ?? [],
          },
          {
            type: "select",
            label: "Tag",
            name: "tag",
            options: blogTagResponse?.data ?? [],
          },
          {
            type: "select",
            label: "Blog",
            name: "blog",
            options: blogResponse?.data ?? [],
          },
        ],
        components: html`
          <section class="md:my-10 mt-4 reliable-blog-list">
            <div class="container mx-auto px-4">
              <div class="grid gap-y-4 md:grid-cols-5 gap-x-4">
                <div class="col-span-2">
                  <div class="sticky top-4">
                    <div></div>
                    <div class="flex flex-col gap-y-3   ">
                      <div class="flex items-center gap-x-2">
                        <div
                          class="border-s-4 border-[#FA6914] md:h-7 h-5 relative"
                        ></div>
                        <h2
                          class="text-xl text-[var(--primary)] font-medium md:font-semibold font-montserrat md:text-3xl"
                        >
                          Categories
                        </h2>
                      </div>

                      <ul class="text-gray-600">
                        <!-- {% blog_categories as categories %} -->
                        <!-- {% for category in categories %} -->

                        <li class="flex items-center gap-x-2">
                          <svg
                            width="8"
                            height="14"
                            viewBox="0 0 8 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.536879 1.13736L1.59788 0.077364L7.37688 5.85436C7.47003 5.94693 7.62045 5.73311 7.6709 5.85436C7.72135 5.97561 7.67083 6.42954 7.67083 6.56086C7.67083 6.69219 7.64486 6.82222 7.59441 6.94347C7.54396 7.06472 7.47003 7.1748 7.37688 7.26736L1.59788 13.0474L0.537878 11.9874L5.96188 6.56236L0.536879 1.13736Z"
                              fill="#949494"
                            />
                          </svg>
                          <span>
                            <!-- {% comment %} -->
                            Lorem
                            <!-- {% endcomment %} -->
                            <!-- {{category.name}} -->
                          </span>
                        </li>
                        <!-- {% endfor %} -->
                        <!-- {% comment %} -->
                        <li class="flex items-center gap-x-2">
                          <svg
                            width="8"
                            height="14"
                            viewBox="0 0 8 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.536879 1.13736L1.59788 0.077364L7.37688 5.85436C7.47003 5.94693 7.62045 5.73311 7.6709 5.85436C7.72135 5.97561 7.67083 6.42954 7.67083 6.56086C7.67083 6.69219 7.64486 6.82222 7.59441 6.94347C7.54396 7.06472 7.47003 7.1748 7.37688 7.26736L1.59788 13.0474L0.537878 11.9874L5.96188 6.56236L0.536879 1.13736Z"
                              fill="#949494"
                            />
                          </svg>
                          <span>Lorem ipsum</span>
                        </li>
                        <li class="flex items-center gap-x-2">
                          <svg
                            width="8"
                            height="14"
                            viewBox="0 0 8 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.536879 1.13736L1.59788 0.077364L7.37688 5.85436C7.47003 5.94693 7.62045 5.73311 7.6709 5.85436C7.72135 5.97561 7.67083 6.42954 7.67083 6.56086C7.67083 6.69219 7.64486 6.82222 7.59441 6.94347C7.54396 7.06472 7.47003 7.1748 7.37688 7.26736L1.59788 13.0474L0.537878 11.9874L5.96188 6.56236L0.536879 1.13736Z"
                              fill="#949494"
                            />
                          </svg>
                          <span>Lorem ipsum</span>
                        </li>
                        <!-- {% endcomment %} -->
                      </ul>
                    </div>
                    <div class="mt-6">
                      <div class="flex items-center gap-x-2 mb-6">
                        <div
                          class="border-s-4 border-[#FA6914] md:h-7 h-5 relative"
                        ></div>
                        <h2
                          class="text-xl text-[var(--primary)] font-medium md:font-semibold font-montserrat md:text-3xl"
                        >
                          Recent Post
                        </h2>
                      </div>
                      <hr class="text-gray-300" />
                      <div class="flex flex-col gap-y-1">
                        <!-- {% blogs as blogs %} -->
                        <!-- {% for blog in blogs %} -->
                        <div class="flex gap-x-2 my-2">
                          <div class="w-32 h-20 flex-none">
                            <!-- {% comment %} -->
                            <img
                              class="w-full h-20 object-contain rounded overflow-hidden"
                            />
                            <!-- {% endcomment %} -->
                            <!-- <img
                            src="{% generate_thumbnail blog.preview_image_url '400x350/filters:format(webp)' %}"
                           alt="{{ blog.headline }}"
                             class="w-full h-20 object-cover rounded overflow-hidden"
                           /> -->
                          </div>
                          <div>
                            <span class="text-xs text-gray-400 mb-2">
                              <!-- {% comment %} -->
                              Jan 06, 2025
                              <!-- {% endcomment %} -->
                              <!-- {{ blog.created | date:"b d, Y" | capfirst }} -->
                            </span>
                            <h3
                              class="text-xl font-semibold text-[var(--primary)] line-clamp-2"
                            >
                              <!-- {% comment %} -->
                              Scam Alert
                              <!-- {% endcomment %} -->
                              <!-- {{ blog.headline|title }}  -->
                            </h3>
                          </div>
                        </div>
                        <!-- {% endfor %} -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-1 gap-x-4 gap-y-6 col-span-3 ">
                  <!-- {% blogs as blogs %} -->
                  <!-- {% for blog in blogs %} -->
                  <div class="p-2 ">
                    <div
                      class="bg-white rounded-lg overflow-hidden flex flex-col mx-auto "
                    >
                      <div class="w-full rounde-lg overflow-hidden">
                        <!-- {% comment %} -->
                        <img
                          src="https://via.placeholder.com/100"
                          alt="blog_img"
                          class="w-full h-96 object-cover rounded-lg overflow-hidden"
                        />

                        <!-- {% endcomment %} -->

                        <!-- <img
                        src="{% generate_thumbnail blog.preview_image_url '1100x650/filters:format(webp)' %}"
                        alt="{{ blog.headline }}"
                     class="w-full h-96 object-cover rounded-lg overflow-hidden"
                      /> -->
                      </div>
                      <div class="py-4">
                        <div
                          class="flex items-center gap-x-4 text-primary text-xs md:text-sm mb-2"
                        >
                          <span class="flex items-center gap-x-2">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 37 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M32.4146 25.6803L24.1669 24.1827C23.4146 22.678 23.4146 22.0241 23.4146 21.1803C24.1669 20.428 25.6646 19.6827 25.6646 18.9303C26.4169 16.6803 26.4169 15.1827 26.4169 15.1827C26.8036 14.6202 27.9146 13.685 27.9146 12.1803C27.9146 10.6756 26.4169 9.17798 26.4169 8.43267C26.4169 2.42798 23.3583 0.177979 18.9146 0.177979C14.6606 0.177979 11.4122 2.42798 11.4122 8.42564C11.4122 9.17798 9.91455 10.6756 9.91455 12.1733C9.91455 13.6709 10.9833 14.6624 11.4122 15.1756C11.4122 15.1756 11.4122 16.6733 12.1646 18.9233C12.1646 19.6756 13.6622 20.4209 14.4146 21.1733C14.4146 21.9256 14.4146 22.6709 13.6622 24.1756L5.41455 25.6803C2.41221 26.4256 0.914551 31.678 0.914551 36.178H36.9146C36.9146 31.678 35.4169 26.4256 32.4146 25.6803Z"
                                fill="#FA6914"
                              />
                            </svg>
                            <!-- {% comment %} -->
                            XYZ
                            <!-- {% endcomment %} -->
                            <!-- {{ blog.author.display_name }} -->
                          </span>
                          <span class="flex gap-x-2 items-center">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 31 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.914551 6.67798C0.914551 3.84898 0.914551 2.43598 1.79355 1.55698C2.67255 0.677978 4.08555 0.677979 6.91455 0.677979H24.9146C27.7436 0.677979 29.1565 0.677978 30.0355 1.55698C30.9146 2.43598 30.9146 3.84898 30.9146 6.67798C30.9146 7.38448 30.9146 7.73848 30.6956 7.95898C30.475 8.17798 30.1196 8.17798 29.4146 8.17798H2.41455C1.70805 8.17798 1.35405 8.17798 1.13355 7.95898C0.914551 7.73848 0.914551 7.38298 0.914551 6.67798ZM0.914551 20.178C0.914551 23.007 0.914551 24.42 1.79355 25.299C2.67255 26.178 4.08555 26.178 6.91455 26.178H24.9146C27.7436 26.178 29.1565 26.178 30.0355 25.299C30.9146 24.42 30.9146 23.007 30.9146 20.178V12.678C30.9146 11.9715 30.9146 11.6175 30.6956 11.397C30.475 11.178 30.1196 11.178 29.4146 11.178H2.41455C1.70805 11.178 1.35405 11.178 1.13355 11.397C0.914551 11.6175 0.914551 11.973 0.914551 12.678V20.178Z"
                                fill="#FA6914"
                              />
                            </svg>

                            <!-- {% comment %} -->
                            Jan 06, 2025
                            <!-- {% endcomment %} -->

                            <!-- {{ blog.created | date:"b d, Y" | capfirst }} -->
                          </span>
                        </div>
                        <div
                          class="flex items-center gap-x-2 my-2 text-gray-500"
                        >
                          <!-- {% for tag in blog.tag.all %}  -->

                          <span
                            class="px-2  border border-[#FA6914] rounded-lg"
                          >
                            <!-- {% comment %} -->
                            Cargo
                            <!-- {% endcomment %} -->
                            <!-- {{ tag.name }} -->
                          </span>
                          <!-- {% comment %} -->
                          <span
                            class="px-2  border border-[#FA6914] rounded-lg"
                          >
                            Transportation
                          </span>
                          <!-- {% endcomment %} -->
                          <!-- {% endfor %} -->
                        </div>
                        <h3
                          class="text-base md:text-xl  font-bold text-[var(--primary)] my-2"
                        >
                          <!-- {% comment %} -->
                          Scam Alert
                          <!-- {% endcomment %} -->
                          <!-- {{ blog.headline|title }}  -->
                        </h3>
                        <p
                          class="text-gray-600 text-sm md:text-base mb-2 line-clamp-4 "
                        >
                          <!-- {% comment %} -->
                          E-commerce Scam Alert: Stay Safe While Shopping Online
                          <!-- {% endcomment %} -->
                          <!-- {{ blog.content|safe }} -->
                        </p>
                        <!-- <a href="{{ blog.absolute_url }}"  class="text-white bg-[#FA6914] w-36 px-3 py-2 rounded-md flex items-center gap-x-2 font-semibold hover:bg-[var(--primary)] mt-2 ripple-effect relative overflow-hidden"> -->
                        <!-- {% comment %} -->
                        <a
                          href="/blog"
                          class="text-white bg-[#FA6914] w-36 px-3 py-2 rounded-md flex items-center gap-x-2 font-semibold hover:bg-[var(--primary)] mt-2 ripple-effect relative overflow-hidden"
                        >
                          <!-- {% endcomment %} -->
                          Read More
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 46 46"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M29.8992 21.0228L22.5502 13.6738C22.2113 13.3229 22.0238 12.8529 22.028 12.3651C22.0323 11.8773 22.2279 11.4106 22.5729 11.0657C22.9178 10.7207 23.3845 10.5251 23.8723 10.5208C24.3601 10.5166 24.8301 10.7041 25.181 11.043L35.7059 21.5679C35.8792 21.7403 36.0168 21.9453 36.1107 22.171C36.2046 22.3967 36.2529 22.6388 36.2529 22.8833C36.2529 23.1278 36.2046 23.3699 36.1107 23.5956C36.0168 23.8213 35.8792 24.0263 35.7059 24.1987L25.181 34.7236C24.8285 35.0541 24.3613 35.2345 23.8781 35.2267C23.395 35.2188 22.9338 35.0233 22.5923 34.6815C22.2507 34.3397 22.0555 33.8785 22.048 33.3953C22.0405 32.9122 22.2213 32.4451 22.5521 32.0928L29.9011 24.7438L12.0662 24.7438C11.5728 24.7438 11.0996 24.5478 10.7507 24.1989C10.4018 23.85 10.2057 23.3767 10.2057 22.8833C10.2057 22.3899 10.4018 21.9166 10.7507 21.5677C11.0996 21.2188 11.5728 21.0228 12.0662 21.0228L29.8992 21.0228Z"
                              fill="#FEFEFE"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!-- {% endfor %} -->
                </div>
              </div>
              <div class="flex w-full justify-center mt-4">
                <button class="text-red-400">Load More...</button>
              </div>
              <hr class=" my-2 border-gray-400" />
            </div>
          </section>
        `,
      },
    },
  });
};
